// Food substitution lists by category
export const FOOD_GROUPS = [
  {
    name: "Proteínas",
    color: "#39FF14",
    foods: [
      { name: "Pechuga de pollo", portion: "100g", kcal: 165, protein: 31, carbs: 0, fat: 3.6 },
      { name: "Pavo (pechuga)", portion: "100g", kcal: 135, protein: 30, carbs: 0, fat: 1 },
      { name: "Atún en agua", portion: "100g", kcal: 116, protein: 26, carbs: 0, fat: 1 },
      { name: "Salmón", portion: "100g", kcal: 208, protein: 20, carbs: 0, fat: 13 },
      { name: "Huevo entero", portion: "1 unidad", kcal: 78, protein: 6, carbs: 0.6, fat: 5 },
      { name: "Clara de huevo", portion: "100g", kcal: 52, protein: 11, carbs: 0.7, fat: 0.2 },
      { name: "Carne de res magra", portion: "100g", kcal: 250, protein: 26, carbs: 0, fat: 15 },
      { name: "Whey protein", portion: "30g", kcal: 120, protein: 24, carbs: 3, fat: 1.5 },
      { name: "Tofu firme", portion: "100g", kcal: 144, protein: 17, carbs: 3, fat: 9 },
      { name: "Lentejas cocidas", portion: "100g", kcal: 116, protein: 9, carbs: 20, fat: 0.4 },
    ],
  },
  {
    name: "Carbohidratos",
    color: "#FFD700",
    foods: [
      { name: "Arroz blanco cocido", portion: "100g", kcal: 130, protein: 2.7, carbs: 28, fat: 0.3 },
      { name: "Arroz integral", portion: "100g", kcal: 112, protein: 2.6, carbs: 24, fat: 0.9 },
      { name: "Avena cruda", portion: "100g", kcal: 389, protein: 17, carbs: 66, fat: 7 },
      { name: "Patata cocida", portion: "100g", kcal: 87, protein: 1.9, carbs: 20, fat: 0.1 },
      { name: "Patata dulce", portion: "100g", kcal: 86, protein: 1.6, carbs: 20, fat: 0.1 },
      { name: "Pasta integral cocida", portion: "100g", kcal: 124, protein: 5, carbs: 26, fat: 1.4 },
      { name: "Pan integral", portion: "1 rebanada", kcal: 80, protein: 4, carbs: 14, fat: 1 },
      { name: "Quinoa cocida", portion: "100g", kcal: 120, protein: 4.4, carbs: 21, fat: 1.9 },
      { name: "Plátano", portion: "1 mediano", kcal: 105, protein: 1.3, carbs: 27, fat: 0.4 },
      { name: "Frijoles negros", portion: "100g", kcal: 132, protein: 8.9, carbs: 24, fat: 0.5 },
    ],
  },
  {
    name: "Grasas saludables",
    color: "#FF8C00",
    foods: [
      { name: "Aguacate", portion: "100g", kcal: 160, protein: 2, carbs: 9, fat: 15 },
      { name: "Almendras", portion: "30g", kcal: 173, protein: 6, carbs: 6, fat: 15 },
      { name: "Nueces", portion: "30g", kcal: 196, protein: 4.5, carbs: 4, fat: 19 },
      { name: "Aceite de oliva", portion: "1 cda", kcal: 119, protein: 0, carbs: 0, fat: 13.5 },
      { name: "Mantequilla de maní", portion: "1 cda", kcal: 94, protein: 4, carbs: 3, fat: 8 },
      { name: "Semillas de chía", portion: "15g", kcal: 73, protein: 2.5, carbs: 6, fat: 4.7 },
      { name: "Semillas de linaza", portion: "15g", kcal: 80, protein: 2.7, carbs: 4.3, fat: 6.3 },
    ],
  },
  {
    name: "Vegetales",
    color: "#39FF14",
    foods: [
      { name: "Brócoli", portion: "100g", kcal: 34, protein: 2.8, carbs: 7, fat: 0.4 },
      { name: "Espinacas", portion: "100g", kcal: 23, protein: 2.9, carbs: 3.6, fat: 0.4 },
      { name: "Pepino", portion: "100g", kcal: 16, protein: 0.7, carbs: 3.6, fat: 0.1 },
      { name: "Tomate", portion: "100g", kcal: 18, protein: 0.9, carbs: 3.9, fat: 0.2 },
      { name: "Lechuga", portion: "100g", kcal: 15, protein: 1.4, carbs: 2.9, fat: 0.2 },
      { name: "Zanahoria", portion: "100g", kcal: 41, protein: 0.9, carbs: 10, fat: 0.2 },
      { name: "Pimiento", portion: "100g", kcal: 31, protein: 1, carbs: 6, fat: 0.3 },
    ],
  },
];

export const NUTRITION_TEMPLATES = {
  fat_loss: {
    title: "Pérdida de grasa",
    description: "Déficit calórico moderado, alta proteína para preservar masa muscular.",
    calorie_adjust: -20,
    macros: { protein_per_kg: 2.2, fat_per_kg: 0.8 },
    meals: [
      { name: "Desayuno", foods: "Avena (50g) + claras de huevo (4) + 1 fruta", notes: "Fibra + proteína" },
      { name: "Media mañana", foods: "Whey protein (30g) + almendras (15g)", notes: "Saciedad" },
      { name: "Almuerzo", foods: "Pechuga de pollo (180g) + arroz integral (80g) + ensalada", notes: "Comida principal" },
      { name: "Merienda", foods: "Yogur griego + chía (15g)", notes: "Pre-entreno" },
      { name: "Cena", foods: "Pescado blanco (200g) + brócoli + patata pequeña", notes: "Bajo en carbos" },
    ],
  },
  muscle_gain: {
    title: "Ganancia muscular",
    description: "Superávit calórico controlado, énfasis en proteína y carbohidratos.",
    calorie_adjust: 15,
    macros: { protein_per_kg: 2.0, fat_per_kg: 1.0 },
    meals: [
      { name: "Desayuno", foods: "Avena (80g) + 3 huevos + 1 plátano + mantequilla de maní", notes: "Energía sostenida" },
      { name: "Media mañana", foods: "Sándwich integral + atún + aguacate", notes: "Macros completos" },
      { name: "Pre-entreno", foods: "Arroz (100g) + pollo (150g)", notes: "1h antes del gym" },
      { name: "Post-entreno", foods: "Whey (40g) + plátano + creatina", notes: "Recuperación" },
      { name: "Cena", foods: "Carne magra (200g) + patata dulce (200g) + vegetales", notes: "Reparación" },
      { name: "Antes de dormir", foods: "Yogur griego + nueces", notes: "Caseína natural" },
    ],
  },
  recomposition: {
    title: "Recomposición corporal",
    description: "Mantener calorías, ciclar carbohidratos según entrenamiento.",
    calorie_adjust: -10,
    macros: { protein_per_kg: 2.2, fat_per_kg: 0.9 },
    meals: [
      { name: "Desayuno", foods: "Tortilla de 2 huevos + claras (3) + avena (40g)", notes: "Proteína alta" },
      { name: "Media mañana", foods: "Manzana + 20g almendras + 1 huevo duro", notes: "Snack" },
      { name: "Almuerzo (día de gym)", foods: "Pollo (180g) + arroz (100g) + ensalada", notes: "Carbos altos" },
      { name: "Almuerzo (descanso)", foods: "Pescado (200g) + ensalada grande + aguacate", notes: "Carbos bajos" },
      { name: "Cena", foods: "Carne magra (180g) + verduras + 1 cda aceite oliva", notes: "Proteína + grasa" },
    ],
  },
};
